import { useState } from 'react';
import { useQuery } from 'react-query';
import { config } from '@abyss/ui/tools/config';
import { getFeature } from 'src/tools/features';

export const useAdminContext = opts2 => {
  const [options, setOptions] = useState({ enabled: false });

  const queryResult = useQuery(
    ['userLookup', options.variables],
    queryInfo => {
      const [, vars] = queryInfo.queryKey;
      const params = JSON.stringify(vars);

      const url = `${
        getFeature('OHID_SESSION_REWORK')
          ? `${config('IDENTITY_API_URL')}/usercontext/v2`
          : `${config('IDENTITY_API_URL')}/usercontext`
      }`;

      setOptions({ enabled: false });

      return fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: params,
      })
        .then(res => {
          if (!res.ok) {
            return res.json().then(result => {
              throw result;
            });
          }

          return res;
        })
        .then(data => {
          if (opts2 && opts2.onCompleted) {
            opts2.onCompleted(data);
          }
        })
        .catch(error => {
          if (opts2 && opts2.onError) {
            opts2.onError(error);
          }
        });
    },
    {
      enabled: options.enabled,
    }
  );

  const queryAction = opts => {
    setOptions({ enabled: true, ...opts });
  };

  return [queryResult, queryAction];
};
